// extracted by mini-css-extract-plugin
export default {"error":"withCommonPage__error--276"};